var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _g, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _g2, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _g4, _path11, _path12, _rect17, _rect18, _rect19, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path107, _path108;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 740.433,
    height: 645.772,
    viewBox: "0 0 740.433 645.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "app_development_",
    "data-name": "app development ",
    transform: "translate(-2268.417 -1226.354)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M2952.139,1552.3c0,173.758-41.754,286.338-280.792,315.268-88.688,10.734-101.18-138.827-199.228-137.347-143.812,2.17-166.161-100.895-157.415-141.036,27.717-127.223,235.469-438.064,358.558-346.078C2914.243,1423.2,2952.139,1378.547,2952.139,1552.3Z",
    transform: "translate(-0.62 0)",
    fill: "#0095ff",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M3008.85,1563.513c0,173.758-210.86,233.25-443.067,302.973-142.488,42.784-317.775-152.174-295.427-300.8,28.567-189.978,217.979-381.651,341.068-289.665C2852.406,1456.109,3008.85,1389.756,3008.85,1563.513Z",
    transform: "translate(0 -0.36)",
    fill: "#0095ff",
    opacity: 0.09
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 33.446,
    height: 23.067,
    rx: 3.402,
    transform: "matrix(0.814, -0.581, 0.581, 0.814, 2709.47, 1495.845)",
    fill: "#f8c4d5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "translate(2764.882 1470.853) rotate(10.735)",
    fill: "#f8c4d5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "translate(2740.786 1599.078) rotate(10.735)",
    fill: "#f8c4d5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "matrix(0.814, -0.581, 0.581, 0.814, 2783.531, 1603.116)",
    fill: "#f8bbd0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "matrix(0.573, 0.82, -0.82, 0.573, 2820.387, 1491.715)",
    fill: "#f8c4d5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "matrix(0.573, 0.82, -0.82, 0.573, 2712.546, 1565.214)",
    fill: "#f8bbd0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "translate(2716.859 1522.855) rotate(99.952)",
    fill: "#f8bbd0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 33.446,
    height: 23.066,
    rx: 3.402,
    transform: "translate(2845.448 1546.078) rotate(99.952)",
    fill: "#f8c4d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M2838.363,1538.237a66.843,66.843,0,1,0-50.91,79.65A66.844,66.844,0,0,0,2838.363,1538.237Zm-59.388,42.35a28.335,28.335,0,1,1,21.578-33.758A28.331,28.331,0,0,1,2778.975,1580.587Z",
    transform: "translate(-6.078 -3.601)",
    fill: "#f8c4d5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(2729.031 1511.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M2773.485,1590.989a38.038,38.038,0,0,1-37.077-29.813h0a37.946,37.946,0,1,1,37.077,29.813Zm-36.712-29.892a37.6,37.6,0,1,0,28.637-44.8,37.639,37.639,0,0,0-28.637,44.8Z",
    transform: "translate(-2735.516 -1515.042)",
    fill: "#fff"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "matrix(0.814, -0.581, 0.581, 0.814, 2793.348, 1591.833)",
    fill: "#f8abab"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "matrix(0.982, 0.186, -0.186, 0.982, 2823.567, 1578.204)",
    fill: "#f8abab"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "matrix(0.982, 0.186, -0.186, 0.982, 2810.427, 1648.13)",
    fill: "#f8abab"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "matrix(0.814, -0.581, 0.581, 0.814, 2833.737, 1650.333)",
    fill: "#f8abab"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "translate(2853.836 1589.581) rotate(55.041)",
    fill: "#f8abab"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "translate(2795.025 1629.663) rotate(55.041)",
    fill: "#f8abab"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "translate(2797.378 1606.563) rotate(99.952)",
    fill: "#f8abab"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 18.24,
    height: 12.579,
    rx: 1.855,
    transform: "translate(2867.503 1619.227) rotate(99.952)",
    fill: "#f8abab"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M2867.643,1618.028a36.452,36.452,0,1,0-27.763,43.435A36.452,36.452,0,0,0,2867.643,1618.028Zm-32.387,23.095a15.452,15.452,0,1,1,11.767-18.41A15.45,15.45,0,0,1,2835.256,1641.123Z",
    transform: "translate(-7.319 -5.04)",
    fill: "#f8abab"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(2804.017 1600.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M2832.262,1646.8a20.721,20.721,0,1,1,4.456-.486A20.742,20.742,0,0,1,2832.262,1646.8Zm.006-41.214a20.5,20.5,0,1,0,20.022,16.1A20.494,20.494,0,0,0,2832.268,1605.581Z",
    transform: "translate(-2811.557 -1605.378)",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 33.483,
    cy: 33.483,
    r: 33.483,
    transform: "translate(2775.49 1368.81) rotate(-4.116)",
    fill: "#ffdc14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M2787.937,1453.5c-1.856,1.1-3.808,2.394-6.81.49s-5.02-3.583-5.3-4.381,2.033-4.834,2.393-5.009S2787.937,1453.5,2787.937,1453.5Z",
    transform: "translate(-7.044 -3.03)",
    fill: "#666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M2772.188,1439.854c-.825,1.994-1.825,4.113.49,6.811s4.264,4.455,5.094,4.619,4.493-2.7,4.615-3.086S2772.188,1439.854,2772.188,1439.854Z",
    transform: "translate(-6.981 -2.964)",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M2799.859,1444.206c-2.551,3.16-8.052,12.188-13.638,9.018s-9.014-6.693-9.078-7.582,7.362-10.749,8.874-11.106S2799.859,1444.206,2799.859,1444.206Z",
    transform: "translate(-7.063 -2.89)",
    fill: "#757575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M2779.409,1426.459c-2.762,2.977-10.908,9.714-6.972,14.789s7.915,7.963,8.8,7.9,9.584-8.825,9.721-10.373S2779.409,1426.459,2779.409,1426.459Z",
    transform: "translate(-6.983 -2.778)",
    fill: "#757575"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M2829.876,1432.24c.686-2.1-7.412-15.075-16.065-22.356-7.854,10.052-18.57,17-26.136,27.2,5.181,4.285,11.6,8.468,12.675,8.1,1.839-.629,4.269-4.077,9.683-6.054S2828.982,1434.983,2829.876,1432.24Z",
    transform: "translate(-7.209 -2.548)",
    fill: "#ffdc14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M2786.806,1394.856c1.985-.979,15.981,5.178,24.427,12.7-8.823,9.212-14.165,20.811-23.174,29.76-4.981-4.513-10.04-10.264-9.83-11.384.359-1.911,3.423-4.81,4.6-10.451S2784.22,1396.134,2786.806,1394.856Z",
    transform: "translate(-7.078 -2.338)",
    fill: "#ffdc14"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(2764.521 1424.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M2779.481,1446.853c-6.581-5.7-8.374-10.005-7.9-11.969a1.149,1.149,0,0,1,.776-.933c.718-.179,1.089.423,1.763,1.52a39.692,39.692,0,0,0,6.756,8.284c7.151,6.973,11.572,8.328,12.581,7.891-.2-.495-1.883-1.837-3.518-3.137-2.039-1.624-4.58-3.644-7.237-6.184-6.143-5.87-8.734-11.018-8.242-12.477a.636.636,0,0,1,.489-.471c.51-.088.911.417,2.1,1.906a71.279,71.279,0,0,0,7.589,8.277c6.542,6.1,10.588,7.135,11.424,6.918a30.14,30.14,0,0,0-4.317-3.349c-1.715-1.208-3.488-2.456-4.833-3.592l-.189-.163c-3.354-2.9-9.245-9.732-9.439-11.254a.419.419,0,1,1,.832-.107c.144,1.126,5.814,7.926,9.338,10.883,1.317,1.111,3.074,2.35,4.774,3.547,4.066,2.864,5.053,3.669,4.667,4.406a.914.914,0,0,1-.714.45c-1.31.224-5.535-.98-12.116-7.126a71.92,71.92,0,0,1-7.672-8.366c-.445-.558-.872-1.094-1.151-1.386.117,1.391,2.265,5.779,8.042,11.3,2.629,2.512,5.153,4.521,7.181,6.135,2.786,2.218,3.914,3.148,3.848,3.918a.738.738,0,0,1-.4.589c-1.72.946-6.951-1.5-13.617-8a40.411,40.411,0,0,1-6.885-8.445c-.324-.527-.687-1.125-.831-1.147-.033.007-.126.082-.183.333-.315,1.415.946,5.4,7.758,11.221,6.759,5.818,9.251,6.183,9.276,6.186a.421.421,0,0,1,.369.462.415.415,0,0,1-.452.374c-.106-.009-2.68-.307-9.742-6.385Z",
    transform: "translate(-2771.506 -1427.645)",
    fill: "#b3b3b3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(2780.562 1404.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M2787.917,1437.806l0,0a.419.419,0,0,1-.037-.593l.388-.439c3.623-4.1,10.249-11.594,12.54-18.475a7.884,7.884,0,0,1-5.92-5.543,4.36,4.36,0,0,1,1.1-4.394,3.314,3.314,0,0,1,3.344-1.067c1.047.325,2.416,1.437,2.988,4.877a12.67,12.67,0,0,1-.449,5.5,28.868,28.868,0,0,0,8.454.092q1.052-.111,2.032-.26c4.794-5.4,7.936-7.83,10.1-7.855a2.383,2.383,0,0,1,1.87.819,1.95,1.95,0,0,1,.363,2.1c-.785,2.057-4.816,4.589-11.909,5.722q-.4.445-.8.918c-6.3,7.275-19.255,21.5-19.385,21.642a.409.409,0,0,1-.592.028.419.419,0,0,1-.028-.593c.13-.143,13.081-14.361,19.371-21.627l.161-.185q-.536.07-1.094.128a29.851,29.851,0,0,1-8.792-.109c-2.34,7.095-9.049,14.685-12.723,18.842l-.387.438A.421.421,0,0,1,2787.917,1437.806Zm11.922-29.277a2.11,2.11,0,0,0-.76-.433,2.5,2.5,0,0,0-2.491.847,3.518,3.518,0,0,0-.91,3.534,7.164,7.164,0,0,0,5.379,5,11.9,11.9,0,0,0,.431-5.173A6.388,6.388,0,0,0,2799.838,1408.529Zm23.7,2.339a1.55,1.55,0,0,0-1.075-.382c-1.767.02-4.649,2.245-8.782,6.787,5.887-1.1,9.537-3.222,10.221-5.01a1.106,1.106,0,0,0-.2-1.234A1.758,1.758,0,0,0,2823.543,1410.868Z",
    transform: "translate(-2787.771 -1407.171)",
    fill: "#e6bd00"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M2742.044,1402.96v388.553a29,29,0,0,1-28.915,28.915H2510.222a15.28,15.28,0,0,1-15.231-15.232V1402.96a29,29,0,0,1,28.916-28.915H2713.13A29,29,0,0,1,2742.044,1402.96Z",
    transform: "translate(-3.146 -2.05)",
    fill: "#015da6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M2510.4,1807.914a2.4,2.4,0,0,1-1.417-.453,2.589,2.589,0,0,1-1.121-2.086V1403.139a16.24,16.24,0,0,1,16.223-16.221h189.223a16.24,16.24,0,0,1,16.223,16.221v388.553a16.241,16.241,0,0,1-16.223,16.222Z",
    transform: "translate(-3.324 -2.229)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 85.242,
    height: 52.405,
    rx: 2.623,
    transform: "translate(2523.68 1425.594)",
    fill: "#c7dbff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 85.242,
    height: 52.405,
    rx: 2.623,
    transform: "translate(2621.822 1425.594)",
    fill: "#c7dbff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 164.205,
    height: 95.427,
    rx: 4.802,
    transform: "translate(2533.269 1601.849)",
    fill: "#c7dbff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M2658.864,1530.411h-79.031a5.183,5.183,0,0,1-5.183-5.182h0a5.183,5.183,0,0,1,5.183-5.183h79.031a5.182,5.182,0,0,1,5.182,5.183h0A5.182,5.182,0,0,1,2658.864,1530.411Z",
    transform: "translate(-4.251 -4.077)",
    fill: "#a3bbff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M2634.914,1573.11h-30.448a5.182,5.182,0,0,1-5.182-5.182h0a5.182,5.182,0,0,1,5.182-5.183h30.448a5.183,5.183,0,0,1,5.182,5.183h0A5.182,5.182,0,0,1,2634.914,1573.11Z",
    transform: "translate(-4.594 -4.67)",
    fill: "#8ba3f0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M2698.171,1542.728H2539.459a3.238,3.238,0,0,1-3.238-3.239h0a3.239,3.239,0,0,1,3.238-3.239h158.712a3.239,3.239,0,0,1,3.239,3.239h0A3.239,3.239,0,0,1,2698.171,1542.728Z",
    transform: "translate(-3.719 -4.302)",
    fill: "#c7d6ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M2677.685,1556.961H2560.972a3.239,3.239,0,0,1-3.238-3.239h0a3.238,3.238,0,0,1,3.238-3.239h116.713a3.238,3.238,0,0,1,3.238,3.239h0A3.239,3.239,0,0,1,2677.685,1556.961Z",
    transform: "translate(-4.016 -4.5)",
    fill: "#e6eeff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M2683.433,1735.808H2555.061a3.24,3.24,0,0,1-3.24-3.24h0a3.24,3.24,0,0,1,3.24-3.239h128.371a3.24,3.24,0,0,1,3.24,3.239h0A3.24,3.24,0,0,1,2683.433,1735.808Z",
    transform: "translate(-3.935 -6.983)",
    fill: "#e6eeff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M2683.433,1747.961H2555.061a3.24,3.24,0,0,1-3.24-3.239h0a3.24,3.24,0,0,1,3.24-3.239h128.371a3.24,3.24,0,0,1,3.24,3.239h0A3.24,3.24,0,0,1,2683.433,1747.961Z",
    transform: "translate(-3.935 -7.151)",
    fill: "#e6eeff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M2683.433,1760.114H2555.061a3.24,3.24,0,0,1-3.24-3.239h0a3.24,3.24,0,0,1,3.24-3.239h128.371a3.24,3.24,0,0,1,3.24,3.239h0A3.24,3.24,0,0,1,2683.433,1760.114Z",
    transform: "translate(-3.935 -7.32)",
    fill: "#e6eeff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M2683.433,1772.267H2555.061a3.24,3.24,0,0,1-3.24-3.239h0a3.24,3.24,0,0,1,3.24-3.24h128.371a3.24,3.24,0,0,1,3.24,3.24h0A3.24,3.24,0,0,1,2683.433,1772.267Z",
    transform: "translate(-3.935 -7.489)",
    fill: "#e6eeff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M2462.038,1661.621v.053c-.4.739-.844,1.108-1.371,1.108-5.776-.133-20.414-12.607-20.414-12.607a9.94,9.94,0,0,0,2.506-1.635,16.567,16.567,0,0,0,3.692-4.563,19.9,19.9,0,0,0,2.322-9.917s-4.089,6.039-7.675,8.65-8.888,2.822-8.888,2.822,2.637-.818,6.62-4.457h.025a48.861,48.861,0,0,0,4.062-4.219c6.2-7.253,2.189-20.836,8.255-27.245a9.6,9.6,0,0,1,6.225-3.086c3.3-.238,6.593,1.477,8.36,5.618C2465.756,1612.144,2466.337,1654.1,2462.038,1661.621Z",
    transform: "translate(-2.274 -5.278)",
    fill: "#440c01"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M2465,1611.982s-2.321,41.67-2.849,49.714v.053c-.4.739-.844,1.107-1.371,1.107-5.777-.132-20.414-12.606-20.414-12.606a9.921,9.921,0,0,0,2.506-1.635,14.9,14.9,0,0,0,8.888-2.743c6.224-4.114,2.875-8.176,2.215-20.1S2460.726,1611.8,2465,1611.982Z",
    transform: "translate(-2.387 -5.353)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M2456,1620.794c-1.187,4.667-.857,12.785,8.291,14.434s2.966-10.014,1.566-10.962S2456,1620.794,2456,1620.794Z",
    transform: "translate(-2.597 -5.476)",
    fill: "#4f0e01"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M2469.8,1648.081c-.923,1.028-7.885-.29-8.624-1.319-.686-.924,1.345-8.018,2.559-11.974.132-.4.237-.764.343-1.081v-.132a1.094,1.094,0,0,1,1.318-1.186.162.162,0,0,1,.106.026,2.111,2.111,0,0,1,.975.449c1.477,1.029,3.218,3.587,3.139,5.538,0,.317,0,.686.027,1.082.079,1.186.263,2.717.395,4.167C2470.191,1645.681,2470.271,1647.554,2469.8,1648.081Z",
    transform: "translate(-2.674 -5.637)",
    fill: "#ffcab0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M2469.677,1639.49c.079,1.186.263,2.717.4,4.167a11.182,11.182,0,0,0-2.294-3.772,9.348,9.348,0,0,1-2.427-4.167c-.1-.632-.948-.553-1.582-.923.132-.4.237-.764.343-1.081v-.132a7.035,7.035,0,0,1,1.555-.58,2.946,2.946,0,0,1,.844-.132,3.558,3.558,0,0,1,1.715.264c2.346,1.028,1.819,2.057,3.8,5.117a4.119,4.119,0,0,1,.606,2.506A19.573,19.573,0,0,1,2469.677,1639.49Z",
    transform: "translate(-2.712 -5.643)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2477.513,1641.181c-.949.343-2.874.053-4.879-.632a19.559,19.559,0,0,1-2.953-1.266c-1.61-.871-2.876-1.9-3.139-2.9-.211-.765-.527-2.057-.87-3.587a5.88,5.88,0,0,0-.131-.581c-.818-3.692-1.688-8.36-1.4-9.494.422-1.689,11.973-4.774,11.973-4.774.344.606.634,1.214.923,1.846a24.669,24.669,0,0,1,.924,2.453C2480.731,1630.712,2479.438,1640.469,2477.513,1641.181Z",
    transform: "translate(-2.717 -5.436)",
    fill: "#ffcab0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M2465.3,1628c-2.394-1.408-4.226,0-4.436,1.9a4.378,4.378,0,0,0,4.789,4.156C2469.17,1633.846,2465.3,1628,2465.3,1628Z",
    transform: "translate(-2.672 -5.568)",
    fill: "#ffcab0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M2478,1622.262c-.528-.106-1.319-.422-2.268-.606-1.583-.343-4.879.764-8.6,2.875,0,0,2.163-4.009,4.431-4.933a7.337,7.337,0,0,1,5.512.211A24.917,24.917,0,0,1,2478,1622.262Z",
    transform: "translate(-2.759 -5.453)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M2477.323,1620.471c-.264.317-1.873-1.082-6.2,1.161-.369.184-.765.4-1.187.659a15.681,15.681,0,0,0-5.459,5.144l-8.466-6.778c2.109-7.7,7.622-9.548,12.131-8.729a10.544,10.544,0,0,1,4.273,1.767C2476.768,1616.858,2477.613,1620.1,2477.323,1620.471Z",
    transform: "translate(-2.605 -5.35)",
    fill: "#4f0e01"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M2470.73,1774.063c-10,10.846-27.891,31.131-29.721,40.569s.7,15.354-1.127,15.213-9.438-13.1-8.593-14.65,5.776-4.367,7.607-9.86,8.452-28.877,22.4-40.851,14.226-11.27,14.226-11.27Z",
    transform: "translate(-2.26 -7.314)",
    fill: "#f5bca0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M2483.136,1767.922c-1.819,7.042-12.949,51.692-11.841,58.312,1.134,6.62,8.465,7.332,8.6,8.176.158.844-16.616,1.687-17.038.712-.421-1,3.244-7.042,2.822-12.976-.422-5.908-1.556-21.837-.29-36.343s7.754-27.877,7.754-28.589c0-.369-2.8-4.932-5.486-9.626-.317-.5-.607-1.029-.9-1.53-2.295-4.035-4.3-7.859-4.194-8.835.29-2.268,18.33,5.617,18.33,5.617q.552,1.741,1.028,3.324c.712,2.532,1.266,4.774,1.635,6.778A30.756,30.756,0,0,1,2483.136,1767.922Z",
    transform: "translate(-2.696 -7.086)",
    fill: "#ffcab0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M2449.863,1839.3c-.106.528-3.957,1.978-8.071,1.688a11.547,11.547,0,0,1-4.035-.923c-5.091-2.216-11.578-15.112-12.369-16.774a.094.094,0,0,0-.026-.053c-.713-1.476,2.954-6.409,6.065-7.674,0,0,8.15,10.707,8.783,11.473.632.791.369,1.16.791,3.322a3.293,3.293,0,0,0,.553,1.214c1.451,2.4,5.513,5.222,7.359,6.751C2449.519,1838.8,2449.889,1839.143,2449.863,1839.3Z",
    transform: "translate(-2.178 -8.179)",
    fill: "#c76928"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M2495.594,1839.916a13.2,13.2,0,0,1-3.8,2.268h-.052a45.84,45.84,0,0,1-10.233,3.454c-4.72.844-14.77.132-18.357-.527a4.624,4.624,0,0,1-1.239-.317c-1.266-.712-.211-5.3,1-9.1,0,0,11.524.975,15.849-.554a24.717,24.717,0,0,1,4.458.764c3.323.739,7.7,1.873,10.26,2.77C2494.907,1839.2,2495.779,1839.652,2495.594,1839.916Z",
    transform: "translate(-2.678 -8.451)",
    fill: "#c76928"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M2472.145,1652.126c5.446,3.287,15.682,14.461,18.312,15.026s8.921-.564,11.926.563-9.3,8.076-14.087,7.325-12.208-9.3-13.71-12.771S2472.145,1652.126,2472.145,1652.126Z",
    transform: "translate(-2.829 -5.911)",
    fill: "#fabc9e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M2541.555,1656.678c-.027.027-.053.027-.079.052-2.243,1.636-5.09,3.508-8.467,5.591-3.112,1.926-6.7,4.035-10.68,6.224v.027h-.027c-2.98,1.661-6.171,3.429-9.548,5.248-1.213.66-2.479,1.293-3.745,1.978-8.756,4.563-18.646,9.442-29.143,14.347-20.149,9.415-38.716,17.09-52.246,21.811-12.765,4.457-21.02,6.278-21.891,4.431-1.793-3.824,28.536-21.758,67.676-40.061,3.349-1.556,6.646-3.06,9.863-4.51,8.176-3.692,15.929-7.041,23.077-9.942,1.5-.607,2.981-1.214,4.431-1.767,1.451-.581,2.875-1.108,4.246-1.635v-.027c5.3-2.057,10.127-3.8,14.348-5.2,4.14-1.345,7.7-2.373,10.574-3.033a.808.808,0,0,1,.239-.052c4.3-1,6.909-1.028,7.385-.053C2548.069,1651.219,2545.88,1653.512,2541.555,1656.678Z",
    transform: "translate(-1.905 -5.873)",
    fill: "#303769"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M2534.427,1662.318v.105a13.01,13.01,0,0,1-1.872,6.831l-8.6-.607c-.079,0-.132-.052-.21-.079h-.027c-2.98,1.662-6.171,3.429-9.548,5.248a13.279,13.279,0,0,1-6.382-10.707,5.752,5.752,0,0,1-.026-.687v-.553c1.5-.608,2.98-1.214,4.431-1.767,1.451-.581,2.875-1.108,4.246-1.635v-.027a.169.169,0,0,1,0-.159c.29-3.112,2.506-6.277,6.04-9.125a13.248,13.248,0,0,1,8.308,4.087A13.1,13.1,0,0,1,2534.427,1662.318Z",
    transform: "translate(-3.323 -5.87)",
    fill: "#bac0de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M2516.668,1659c-1.593,1.978,1.154,12.693,5.44,12.143s9.231-1.649,6.373-4.067S2516.668,1659,2516.668,1659Z",
    transform: "translate(-3.44 -6.006)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M2566.356,1639.189a.642.642,0,0,1-.054.185,2.076,2.076,0,0,1-.368.474c-.818.871-2.8,2.321-5.248,4.352-.923.765-1.926,1.583-2.981,2.531-.526.449-1.054.949-1.582,1.452-.528.474-1.082,1-1.609,1.53a47.967,47.967,0,0,0-6.462,7.885c-.316.476-.633.976-.922,1.477a19.838,19.838,0,0,1-3.508,4.431,22.027,22.027,0,0,1-7.517,4.668,18.339,18.339,0,0,1-3.429.923,16.462,16.462,0,0,1-8.6-.607c-.08,0-.132-.052-.211-.079h-.026a11.719,11.719,0,0,1-6.963-7.28,3.6,3.6,0,0,1-.184-.712,5.239,5.239,0,0,1-.132-2.109v-.027a.171.171,0,0,1,0-.159c.29-3.112,2.506-6.277,6.04-9.124a35.9,35.9,0,0,1,6.752-4.405c.4-.211.791-.422,1.186-.607.448-.238.923-.449,1.424-.685,10.127-4.616,23.42-7.015,34.154-4.352.079.026.158.052.184.105A.2.2,0,0,1,2566.356,1639.189Z",
    transform: "translate(-3.445 -5.712)",
    fill: "#303769"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M2566.553,1639.189a.658.658,0,0,1-.054.185,2.077,2.077,0,0,1-.369.474c-.818.871-2.8,2.321-5.248,4.352-.949.765-1.952,1.608-2.981,2.531-.527.448-1.054.949-1.582,1.451-.527.475-1.081,1-1.609,1.53a47.937,47.937,0,0,0-6.461,7.885c-.316.475-.633.976-.923,1.477a19.826,19.826,0,0,1-3.507,4.43,12.436,12.436,0,0,0,.052-5.828,2.065,2.065,0,0,0-.658-1.108c-.871-.818-2.375-1.16-3.033-3.059-.317-1,.606-2.241,1.74-3.508a20.266,20.266,0,0,0,2.848-3.4,1.48,1.48,0,0,0,.053-1.635c-1.608-2.057-1.608-.449-7.727.317a8.913,8.913,0,0,1-6.356-1.293c.448-.238.923-.449,1.423-.685a60.645,60.645,0,0,1,17.486-4.958,44.461,44.461,0,0,1,16.668.606c.054.026.079.026.106.052.027,0,.052.027.079.053A.2.2,0,0,1,2566.553,1639.189Z",
    transform: "translate(-3.642 -5.712)",
    fill: "#a1aade"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M2565.5,1677.3a3.166,3.166,0,0,1-2.163.105c-4.958-1.345.5-10.814-.316-16.51l-.027-.026a1.062,1.062,0,0,0-.027-.29c-1.028-5.433-1.661-8.308-.738-7.042C2570.431,1664.854,2569.719,1675.668,2565.5,1677.3Z",
    transform: "translate(-4.065 -5.926)",
    fill: "#a1aade"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M2483.617,1753.062c-.448-.607-1-1.345-1.661-2.242-1.925-2.532-10-1.819-14.242-3.112-.316-.5-.606-1.029-.9-1.53,3.164-.474,11.235-1.45,15.165.106C2482.694,1748.816,2483.248,1751.057,2483.617,1753.062Z",
    transform: "translate(-2.755 -7.206)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M2509.319,1676.17c-8.756,4.563-18.646,9.442-29.143,14.347-20.149,9.416-38.716,17.091-52.245,21.811,12.554-10.022,35.92-25.187,49.371-29.354C2488.352,1679.572,2501.012,1676.566,2509.319,1676.17Z",
    transform: "translate(-2.215 -6.245)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M2488.5,1746.059c-.844.553-26.479,2.821-30.989-4.379-4.51-7.174-4.352-17.169-2.954-30.276.026-.317.079-.633.1-.923,0-.027.026-.027.026-.053,1.5-12.58,5.38-21.415,5.223-26.347-.105-4.062-1.662-9.837-2.216-17.221-.131-1.82-.211-3.745-.184-5.75.158-10.127,2.506-17.749,3.35-17.327,6.778,3.4,8.6,1.134,11.684,5.09a55.277,55.277,0,0,1,8.228,13.925c.923,2.479-.132,4.985-1.318,8.2a34.909,34.909,0,0,0-2,6.91v.027a24.15,24.15,0,0,0-.343,5.3c.422,10.417,5.485,24.079,8.73,41.987C2489.079,1743.1,2489.342,1745.505,2488.5,1746.059Z",
    transform: "translate(-2.572 -5.795)",
    fill: "#fa8e46"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M2479.547,1671.151a34.855,34.855,0,0,0-2,6.91c-1.372-5.223-3.876-5.381-9.732-10.392-6.672-5.67-7.833-9.23-7.094-13.028C2460.717,1654.641,2474.72,1664.637,2479.547,1671.151Z",
    transform: "translate(-2.667 -5.946)",
    fill: "#f06026"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M2563.669,1641.856c-4.062,3.244-11.816,9.179-16.536,17.275a19.827,19.827,0,0,1-3.508,4.431,22.017,22.017,0,0,1-7.517,4.668,18.356,18.356,0,0,1-3.428.923,16.459,16.459,0,0,1-8.6-.607.817.817,0,0,1-.238-.079,11.719,11.719,0,0,1-6.963-7.28,3.551,3.551,0,0,1-.184-.712c5.987,5.407,21.521,1.53,26.742-4.853C2548.186,1649.821,2558.868,1642.99,2563.669,1641.856Z",
    transform: "translate(-3.447 -5.768)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M2511.869,1660.257c-1.186.87-2.716,1.9-4.4,3.007-7.833,5.064-19.543,11.446-21.732,10.417a2.791,2.791,0,0,1-1.371-1.715c8.176-3.692,15.929-7.041,23.077-9.942C2508.942,1661.417,2510.418,1660.811,2511.869,1660.257Z",
    transform: "translate(-2.998 -6.024)",
    fill: "#fff",
    opacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M2531.872,1669.393c.078.871-36.977,11.737-41.118,11.077-4.114-.66-21.494-13.45-26.452-18.25-4.431-4.3-4.588-8.492-2.717-10.154,5.037-4.457,28.8,20.7,29.75,20.888.791.184,4.087-2.084,10.6-2.479a31.393,31.393,0,0,1,3.561-.053c8.94.4,11.841.105,12.686-.079s3.692-2.479,8.7-1.925c.422.052.791.079,1.134.131C2531.713,1668.945,2531.845,1669.024,2531.872,1669.393Z",
    transform: "translate(-2.666 -5.903)",
    fill: "#ffcab0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M2528.605,1668.785a21.986,21.986,0,0,0-8.624,2.479c-2.189,1.161-10.919,1.055-17.459-.553a31.513,31.513,0,0,1,3.561-.053c8.94.4,11.841.105,12.685-.079s3.692-2.479,8.7-1.925C2527.894,1668.706,2528.262,1668.733,2528.605,1668.785Z",
    transform: "translate(-3.251 -6.139)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M2462.639,1686.806c-.553,3.851-5.037,14.663-7.938,23.947,1.5-12.58,5.38-21.416,5.223-26.347-.106-4.062-1.661-9.838-2.216-17.222C2460.477,1676.23,2463.326,1681.689,2462.639,1686.806Z",
    transform: "translate(-2.586 -6.12)",
    fill: "#f06026"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M2491.769,1842.283a45.838,45.838,0,0,1-10.233,3.455c-4.72.844-14.769.132-18.356-.527,4.879-2.269,14.268-2.189,17.908-1.847C2484.516,1843.681,2490.107,1842.441,2491.769,1842.283Z",
    transform: "translate(-2.704 -8.551)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M2441.793,1841.1a11.543,11.543,0,0,1-4.035-.923c-5.09-2.216-11.578-15.112-12.369-16.774,2.031,2.32,9.943,10.074,12.158,13.107A23.1,23.1,0,0,0,2441.793,1841.1Z",
    transform: "translate(-2.18 -8.288)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M2449.142,1838.55a7.014,7.014,0,0,1-2.136,0c-3.27-.4-5.117-4.272-5.223-6.751C2443.234,1834.2,2447.3,1837.021,2449.142,1838.55Z",
    transform: "translate(-2.407 -8.405)",
    fill: "#fff",
    opacity: 0.4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M2493.792,1838.688c-.052.236-.343.474-.976.685-2.769.871-6.408-1.424-9.283-3.455C2486.855,1836.656,2491.233,1837.79,2493.792,1838.688Z",
    transform: "translate(-2.986 -8.462)",
    fill: "#fff",
    opacity: 0.4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M2566.687,1639.005c-2.874.686-12.132.712-16.773-.659a44.459,44.459,0,0,1,16.668.606C2566.635,1638.979,2566.66,1638.979,2566.687,1639.005Z",
    transform: "translate(-3.908 -5.712)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M2565.5,1677.41a3.166,3.166,0,0,1-2.163.106c-4.958-1.345.5-10.814-.316-16.51C2564.734,1666.36,2559.2,1675.96,2565.5,1677.41Z",
    transform: "translate(-4.065 -6.034)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M2449.287,1620.794c.58,8.519-5.407,20.836-10.339,20.281a48.941,48.941,0,0,0,4.062-4.22c6.2-7.253,2.189-20.836,8.255-27.245a9.6,9.6,0,0,1,6.224-3.086C2452.926,1608.347,2448.733,1612.908,2449.287,1620.794Z",
    transform: "translate(-2.367 -5.278)",
    fill: "#ff4747",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M2477.493,1620.474c-.264.317-1.873-1.082-6.2,1.161a32.357,32.357,0,0,1,3.059-3.64c1.346-1.583-2.769-4.4-6.04-6.066a10.547,10.547,0,0,1,4.273,1.767C2476.939,1616.861,2477.783,1620.1,2477.493,1620.474Z",
    transform: "translate(-2.775 -5.352)",
    fill: "#ff4747",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M2788.455,1763.655c-1.521,6.814-2.254,12.109-1.625,17.168.969,7.915,3.093,11.585,2.123,22.174-.971,10.615-6.946,34.335-6.946,36.458s-4.953,2.2-5.163,1.048c-.183-1.153-.236-50.611.158-60.047.183-4.35-.577-10.745-1.285-16.669-.446-3.932-.865-7.653-.944-10.431-.078-2.123.052-3.671.5-4.352,1.913-2.882,16.381,1.547,16.381,1.547-.524,2.1-1.022,4.061-1.467,5.9C2789.529,1759.042,2788.953,1761.427,2788.455,1763.655Z",
    transform: "translate(-7.029 -7.242)",
    fill: "#ffe2d7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M2770.325,1753.332a3.858,3.858,0,0,1-.183,1.258c-.42,1.756-1.494,4.98-2.542,9.174-.577,2.28-1.153,4.874-1.6,7.653-1.6,9.54.42,13.157.577,17.351.6,17.823-7.443,47.938-8.02,49.824-.6,1.861-4.141,1.809-5.426.787-1.127-.865-.34-53.389,1.888-78.813.052-.55.078-1.075.157-1.6.341-3.7.708-6.736,1.127-8.807C2756.3,1750.16,2770.194,1751.891,2770.325,1753.332Z",
    transform: "translate(-6.722 -7.272)",
    fill: "#ffe2d7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M2783.788,1849.014a28.55,28.55,0,0,1-3.3.34c-2.542.158-5.477.106-5.739-.628a17.125,17.125,0,0,1,.55-5.583c.367-1.52.865-2.778,1.336-2.883a12.872,12.872,0,0,1,5.636.236C2783.081,1840.784,2785.728,1848.647,2783.788,1849.014Z",
    transform: "translate(-7.028 -8.52)",
    fill: "#3341b0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M2758.119,1849.09c-.027.026-.079.052-.1.078-1.363.629-13.866-.367-20.6-2.83a12.884,12.884,0,0,1-5.95-3.853c-1.1-1.389-1.073-2.49-.629-2.569.21-.026,1.127-.026,2.385.027,2.857.1,7.6.393,10.484.55,1,.079,1.782.1,2.176.131,1.677.052,12.371-.787,12.371-.787C2758.669,1843.088,2759.351,1848.225,2758.119,1849.09Z",
    transform: "translate(-6.415 -8.516)",
    fill: "#3341b0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M2783.768,1643.093c11.569,4.917,13.739,36.878,13.45,38.179s-14.318-6.941-14.318-8.966S2783.768,1643.093,2783.768,1643.093Z",
    transform: "translate(-7.143 -5.786)",
    fill: "#edc2cc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M2739.609,1681.082c-3.381-1.232-10.9-20.182-11.349-26.472,0,0,1.573,1.179,3.54,2.7,2.1,1.6,4.586,3.59,6.158,5.032a16.185,16.185,0,0,1,3.408,4.351C2745.35,1674.005,2742.441,1682.078,2739.609,1681.082Z",
    transform: "translate(-6.384 -5.945)",
    fill: "#f7dee4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M2786.7,1648.416c3.822,8.082,3.057,22.06,4.587,24.462s5.729,6.014,5.922,8.467-11.711,5.73-14.114-.6S2786.7,1648.416,2786.7,1648.416Z",
    transform: "translate(-7.137 -5.859)",
    fill: "#e3839b"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M2741.37,1666.708c-.918-.629-2.857-2.752-4.142-3.984-1.73-1.625-7.705-4.508-8.7-7l3.277,1.6c2.1,1.6,4.586,3.59,6.159,5.032A16.189,16.189,0,0,1,2741.37,1666.708Z",
    transform: "translate(-6.387 -5.961)",
    fill: "#f2aaba"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M2821.117,1704.565a8.793,8.793,0,0,1-7.443,4.088,7.744,7.744,0,0,1-1.888-.209,8.818,8.818,0,0,1-2.882-1.179l-2.123-1.363-11.323-7.234-58.291-37.193c-.026,0-.078-.026-.078-.052l-2.15-1.363-6.709-4.3a1.348,1.348,0,0,1-.446-.34c-.052,0-.079-.027-.131-.052l-.262-.314-1.73-1.809a8.342,8.342,0,0,1-1.442-3.958,8.551,8.551,0,0,1,.341-3.538,8.24,8.24,0,0,1,1-2.2,8.523,8.523,0,0,1,3.3-3.041,8.8,8.8,0,0,1,4.141-1.022,9.526,9.526,0,0,1,1.494.131l.052.025,2.15.708h.025l.368.131.026.026c.026,0,.052.026.1.053a5.609,5.609,0,0,1,.551.314l8.806,5.608a.026.026,0,0,1,.026.026l57.5,36.693,14.311,9.122a6.51,6.51,0,0,1,.681.5c.157.132.288.262.446.394.011.009.018.022.028.032a8,8,0,0,1,1.256,1.383,5.764,5.764,0,0,1,.5.786,5.984,5.984,0,0,1,.367.708,3.412,3.412,0,0,1,.262.655,3.523,3.523,0,0,1,.236.681l.079.314a5.849,5.849,0,0,1,.157.944A8.7,8.7,0,0,1,2821.117,1704.565Z",
    transform: "translate(-6.327 -5.735)",
    fill: "#604a49"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M2822.122,1705.181a8.8,8.8,0,0,1-7.443,4.088,7.755,7.755,0,0,1-1.888-.209,8.822,8.822,0,0,1-2.882-1.179l-2.123-1.363-11.323-7.235a23.489,23.489,0,0,1,.393-2.725,21.2,21.2,0,0,1,8.257-12.739l14.311,9.122a6.528,6.528,0,0,1,.682.5c.156.131.287.262.446.394a8.2,8.2,0,0,1,1.284,1.415,5.781,5.781,0,0,1,.5.786,6.023,6.023,0,0,1,.366.708,3.415,3.415,0,0,1,.262.655,3.491,3.491,0,0,1,.236.681l.079.315a5.874,5.874,0,0,1,.157.944A8.706,8.706,0,0,1,2822.122,1705.181Z",
    transform: "translate(-7.331 -6.351)",
    fill: "#ab7f80"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M2736.641,1640.839l-5.9,9.3-2.988,4.692a.41.41,0,0,1-.656.079l-1.729-1.808-1.834-1.94-20.156-21.126a.415.415,0,0,1,.446-.682l12.214,4.063,14.652,4.849,3.511,1.206,2.2.734h.025A.436.436,0,0,1,2736.641,1640.839Z",
    transform: "translate(-6.036 -5.594)",
    fill: "#ab7f80"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M2749.3,1658.709a8.951,8.951,0,0,1-2.49,2.568,8.847,8.847,0,0,1-4.98,1.521,8.716,8.716,0,0,1-4.665-1.337c-.026,0-.078-.026-.078-.052l-2.15-1.363-6.709-4.3a1.332,1.332,0,0,1-.446-.34c-.052,0-.079-.026-.131-.052l-.262-.314-1.729-1.809-1.834-1.94a18.289,18.289,0,0,1,.392-2.019,19.812,19.812,0,0,1,1.023-3.04,20.659,20.659,0,0,1,3.616-5.74,16.094,16.094,0,0,1,2.123-2.1l3.512,1.206,2.2.734h.025l.368.131.026.026c.026,0,.052.026.1.053a5.55,5.55,0,0,1,.551.314l8.807,5.608a.026.026,0,0,1,.026.026,9.271,9.271,0,0,1,1.127.865A8.806,8.806,0,0,1,2749.3,1658.709Z",
    transform: "translate(-6.322 -5.72)",
    fill: "#604a49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M2755.2,1759.03c2.228-.681,9.069-2.673,14.966-4.377-.419,1.756-1.494,4.98-2.542,9.174-5.609-.315-10.851-1.337-12.581-3.2a1.974,1.974,0,0,1-.6-1.39S2754.7,1759.161,2755.2,1759.03Z",
    transform: "translate(-6.747 -7.334)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M2790.186,1756.5c-2.2-2.726-7.287-5.242-11.376-4.194-.969.262-2.384.629-4.036,1.1.079,2.777.5,6.5.944,10.431,1.441-.1,2.8-.21,4.01-.393,6.552-.917,8.045-.577,8.727.262Z",
    transform: "translate(-7.03 -7.298)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M2811.5,1708.3a8.815,8.815,0,0,1-2.882-1.179l-2.123-1.363-11.323-7.234-58.291-37.192c-.026,0-.078-.026-.078-.052l-2.149-1.363-6.709-4.3a1.33,1.33,0,0,1-.446-.34c-.052,0-.079-.027-.131-.052l-.262-.315-1.729-1.808-1.834-1.94-20.156-21.126a.415.415,0,0,1,.446-.682l12.214,4.063c-2.044,1.023-3.407,2.909-2.961,4.036.131.341,4.43,3.434,11.191,8.151.209.158.446.314.682.5,1.782,1.232,3.721,2.595,5.792,4.036,4.717,3.277,10.091,7.025,15.778,11.008,16.433,11.4,35.541,24.743,49.039,34.65C2803.136,1701.384,2808.954,1705.84,2811.5,1708.3Z",
    transform: "translate(-6.036 -5.594)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M2790.315,1756.042c-2.333,6.317-33.995,6.789-36.17,2.884s11.008-61.463,12.162-71.292c0,0,3.511-.707,7.47-1.415,2.123-.393,4.376-.76,6.291-1.023h.078c2.49-.34,4.4-.472,4.665-.157a1.334,1.334,0,0,1,.237.419c1.651,3.093,8.858,21.047,10.9,32.553l.079.55C2797.995,1730.8,2793.3,1747.918,2790.315,1756.042Z",
    transform: "translate(-6.74 -6.365)",
    fill: "#6270c9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M2796.247,1718.567c-2.463-8.57-7.679-20.575-11.479-24.087-4.719-4.351-14.094-4.317-14.986-7.542a3.262,3.262,0,0,1-.131-1.153s7.149-.714,10.635-.584h.079c1.441.053,2.962.131,4.4.21a2.967,2.967,0,0,1,.5.052c1.65,3.093,8.858,21.047,10.9,32.553Z",
    transform: "translate(-6.959 -6.37)",
    fill: "#3240b5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M2787.177,1684.071a20.894,20.894,0,0,1-.682,3.854c-.157.236-1.521.367-3.433.392-5.557.131-15.936-.5-16.722-1.311-.577-.6-4.4-12.581-7.155-24.008-2.386-9.908-3.958-19.37-1.914-20.575,4.429-2.621,16.094-4.954,26.132.629,2.2,1.205,3.538,4.56,4.271,8.937C2789.4,1661.9,2788.121,1677.021,2787.177,1684.071Z",
    transform: "translate(-6.774 -5.737)",
    fill: "#f7dee4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M2739.782,1680.892c9.762,5.134,21.549-30.8,21.549-31.744s1.253-9.93-4.291-6.7-16.1,27.165-16.318,29.984S2739.782,1680.892,2739.782,1680.892Z",
    transform: "translate(-6.544 -5.767)",
    fill: "#f7dee4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M2786.273,1649.926a10.657,10.657,0,0,1-2.594,1.494,9.494,9.494,0,0,1-1.154.446,12.878,12.878,0,0,1-5.216.288,20.8,20.8,0,0,1-4.429-4.455c-.157-.236-.315-.471-.472-.734-1.782-2.726-3.957-7.051-3.957-7.051a26.741,26.741,0,0,0,.917,4.744c.132.55.315,1.179.524,1.809a25.212,25.212,0,0,0,2.884,6.159,11.669,11.669,0,0,1-2.491.183c-3.878.21-4.744-.472-4.744-.472s-7.732-15.7-9.671-29.171v-.052c-.839-5.845-.6-11.27,1.861-14.782,1.729-2.49,4.56-4.037,8.884-4.115,5.976-.079,9.725,2.123,13.21,12.344,2.779,8.23,3.2,16.591,3.669,22.095.105,1.337.236,2.516.367,3.46A25.4,25.4,0,0,0,2786.273,1649.926Z",
    transform: "translate(-6.761 -5.246)",
    fill: "#440c01"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M2783.1,1688.646c-5.557.131-15.936-.5-16.722-1.311-.577-.6-4.4-12.581-7.155-24.008,3.983,6.474,9.881,22.069,13.6,22.986,1.022.236,2.306.471,3.669.734A45.359,45.359,0,0,1,2783.1,1688.646Z",
    transform: "translate(-6.814 -6.066)",
    fill: "#f2aaba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M2758.132,1849.128c-.026.026-.079.052-.1.078-1.363.629-13.866-.367-20.6-2.83a12.88,12.88,0,0,1-5.95-3.853,41.509,41.509,0,0,0,8.886,3.12C2746.285,1846.742,2753.284,1847.686,2758.132,1849.128Z",
    transform: "translate(-6.429 -8.554)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M2780.485,1849.4c-2.542.158-5.477.106-5.739-.628a17.124,17.124,0,0,1,.55-5.583C2775.348,1845.232,2776.109,1847.9,2780.485,1849.4Z",
    transform: "translate(-7.028 -8.563)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M2743.742,1840.494c-3.775,1.73-8.334,1.94-10.484-.55C2736.114,1840.049,2740.858,1840.337,2743.742,1840.494Z",
    transform: "translate(-6.453 -8.518)",
    fill: "#fff",
    opacity: 0.4
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M2769.9,1646.733a25.206,25.206,0,0,0,2.884,6.159,11.665,11.665,0,0,1-2.49.183c-3.878.21-4.744-.473-4.744-.473s-7.731-15.7-9.671-29.171c2.149,6.763,6.4,15.465,13.5,21.493C2769.506,1645.475,2769.689,1646.1,2769.9,1646.733Z",
    transform: "translate(-6.767 -5.512)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2783.918,1652.022a9.616,9.616,0,0,1-1.154.446,12.875,12.875,0,0,1-5.216.288,20.794,20.794,0,0,1-4.429-4.455c-.157-.236-.315-.472-.471-.734A27.9,27.9,0,0,0,2783.918,1652.022Z",
    transform: "translate(-7 -5.847)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M2783.528,1638.655c-2.385-6.081-4.272-18.635-8.649-25.423-4.456-6.867-12.685-6.657-17.115-4.9,1.73-2.49,4.561-4.037,8.885-4.115,5.976-.079,9.724,2.123,13.21,12.344C2782.636,1624.791,2783.055,1633.152,2783.528,1638.655Z",
    transform: "translate(-6.794 -5.246)",
    fill: "#ff4747",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M2685.018,1342.8a53.873,53.873,0,0,1-.746,11.406l-1.266-1.515-3.922-4.7s.282-3.108.282-3.956-.282-3.108-.282-3.108-1.222,4.8-1.6,4.8-6.5-4.239-7.731-4.8-7.246.181-9.134-2.826-16.481-24.97-16.481-24.97-.836-7.358-1.56-13.237c-.44-3.583-.836-6.613-.983-7.109-.385-1.312-3.754-17.352-1.515-21.286,1.831-3.222,5.765-5.121,9.733-5.165a11.912,11.912,0,0,1,1.571.079c5.493.633,14.515,3.957,20.731,24.3,5.528,18.076,8.365,25.739,10.185,29.277.237.453.441.825.645,1.154,1.73,2.825,6.386,6.624,6.68,6.861-.3-.091-5.166-1.605-8-5.268-2.917-3.764-4.523-6.116-4.523-6.116s.329,5.426,2.081,8.851C2681.446,1329.906,2684.735,1336.689,2685.018,1342.8Z",
    transform: "translate(-5.149 -0.555)",
    fill: "#3a0982"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M2661.077,1298.286c.147.633-7.844,2.261-7.844,2.261s-.114-1.481-.328-3.267c-.282-2.351-.735-5.256-1.289-6.059,0,0,.034-.192.113-.486.316-1.277,1.345-4.511,3.346-3.187a3.711,3.711,0,0,1,.7.611c.2.214.406.463.621.735A44.2,44.2,0,0,1,2661.077,1298.286Z",
    transform: "translate(-5.32 -0.845)",
    fill: "#ffcab0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M2655.776,1288.171a31.873,31.873,0,0,0-4.047,2.577c-.079.294-.113.486-.113.486.554.8,1.007,3.708,1.289,6.059,1.243-2.046,3.12-5.9,3.492-8.387Z",
    transform: "translate(-5.32 -0.858)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M2638.571,1282.522c0,6.688,3.029,14.607,6.924,15.567,4.874,1.2,12.2-10.2,11.35-13.212s-7.253-11.3-9.891-11.681-6.5,3.58-7.065,5.086S2638.571,1282.522,2638.571,1282.522Z",
    transform: "translate(-5.138 -0.65)",
    fill: "#ffcab0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M2647.755,1333.622s-4.592-6.077-10.456-9.185-7.137-4.734-7.772-6.218-3.038-6.288-3.956-7.205-7.065-7.56-7.347-7.56,2.9,11.869,5.439,15.4,20.7,23.032,23.6,21.76S2647.755,1333.622,2647.755,1333.622Z",
    transform: "translate(-4.856 -1.07)",
    fill: "#ffcab0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M2627.46,1312.945c0-1.519-.388-3.179-1.06-3.356s-1.7-.248-1.907-.035S2627.46,1312.945,2627.46,1312.945Z",
    transform: "translate(-4.943 -1.153)",
    fill: "#ffcab0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M2679.13,1348.465s.282-3.108.282-3.956-.282-3.108-.282-3.108-1.222,4.8-1.595,4.8-6.5-4.239-7.731-4.8-7.247.18-9.135-2.826-16.481-24.971-16.481-24.971-.836-7.358-1.56-13.237c5.053,9.721,14.018,24.327,22.563,29.447,8.8,5.268,16.481,9.315,17.86,23.354Z",
    transform: "translate(-5.195 -1.027)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M2689.278,1376.711c-5.742-1.029-9.042,2.452-11.869.95s-4.895-1.978-5.844-7.631-2.159-23.738-1.594-31.085c.35-4.612-.734-11.032-1.525-15.86-.058-.3-.1-.61-.159-.9a29.547,29.547,0,0,1-.577-5.279c.182-1.752,1.707-5.46,2.781-7.913a.012.012,0,0,1,.012-.012c.226-.52.429-.972.6-1.356.283-.61.464-1,.464-1,.08.136.169.283.249.43.113.192.237.406.35.611s.2.373.3.576c.011.012.011.012.011.023.1.192.2.385.3.588a46.991,46.991,0,0,1,5.189,24.62c-.848,11.869-4.149,37.212-2.634,38.715s5.833-1.786,8.094-1.5,11.869,5.369,12.819,5.651S2695.02,1377.75,2689.278,1376.711Z",
    transform: "translate(-5.543 -1.114)",
    fill: "#ffcab0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M2655.767,1388.248c-.452-.554-4.035-2.374-7.11-3.617a15.107,15.107,0,0,0-3.979-1.187s-6.76-5.02-10.886-8.614c-1.933-1.684-3.289-3.063-3.108-3.47.565-1.266,1.13-.486,5.167.644s12.569,7.62,14.2,7.981,5.369-.147,6.5.351S2656.479,1389.1,2655.767,1388.248Z",
    transform: "translate(-5.029 -2.004)",
    fill: "#ffcab0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M2667.416,1396.96a20.688,20.688,0,0,1-1.537,5.494c-.611,1.266-1.209,1.8-1.526,1.4-.611-.769-4.431-9.406-5.787-11.169s-4.94-4.453-4.613-4.861c.3-.385,2.77-2.814,2.442-4.726s-2.633-4.035-2.487-4.453,10.784,1.639,11.813,4.047c.011.034.033.068.045.1A33.3,33.3,0,0,1,2667.416,1396.96Z",
    transform: "translate(-5.351 -2.114)",
    fill: "#6c50cc"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M2641.879,1349.712c-18.652-.188-48.136,5.463-50.02,11.209s60.853,11.3,61.794,10.456S2641.879,1349.712,2641.879,1349.712Z",
    transform: "translate(-4.49 -1.712)",
    fill: "#907ae0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M2648.7,1384.645a15.111,15.111,0,0,0-3.979-1.187s-6.76-5.02-10.886-8.614c.4-1.819.848-3.164.848-3.164C2637.262,1372.357,2646.485,1378,2648.7,1384.645Z",
    transform: "translate(-5.073 -2.018)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M2591.478,1364.973c.282,4.9,2.26,10.079,13.94,12.811s41.919,7.442,41.919,6.406-10.168-11.8-13.565-13.188c-12.057-4.922-17.827-7.371-26.092-7.63C2594.872,1362.97,2591.478,1364.973,2591.478,1364.973Z",
    transform: "translate(-4.485 -1.901)",
    fill: "#a58cff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M2597.969,1361.981v.033c-.192.939-6.591,5.833-7.54,7.811s-1.13,3.437-2.26,4.714-8.941-2.634-6.963-3.437a19.459,19.459,0,0,0,4.849-3.934c.193-.192.374-.383.554-.576.5-.532.961-1.04,1.345-1.481.124-.147.26-.294.407-.463a50.014,50.014,0,0,1,4.554-3.1,10.353,10.353,0,0,1,2.137-1.006c1.469-.418,2.386-.022,2.747.577A1.157,1.157,0,0,1,2597.969,1361.981Z",
    transform: "translate(-4.338 -1.86)",
    fill: "#ffcab0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M2591.244,1371.736c.238.35-3.584,8.082-5.313,8.828a.47.47,0,0,1-.236.068c-1.583.045-11.349-.565-15.8-4.047a19.923,19.923,0,0,1-2.532-2.351c-2.352-2.634-2.927-4.951-2.623-5.607.4-.847,6.048,1.311,9.959,1.64s7.234-1.787,7.28-1.549c.146.667-.441,3.2,2.137,3.956S2591,1371.351,2591.244,1371.736Z",
    transform: "translate(-4.113 -1.972)",
    fill: "#6c50cc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M2658.423,1284.119c-6.924,7.112-14.129-7.254-14.129-7.254s-1.7,8.949-5.794,7.49.589-13.306,3.015-14.46c3.035-1.443,9.7.943,10.785,2.544S2658.423,1284.119,2658.423,1284.119Z",
    transform: "translate(-5.115 -0.598)",
    fill: "#3a0982"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M2670.637,1318.668c-1.029,1.424-1.786,2.589-2.351,3.516a29.546,29.546,0,0,1-.577-5.279c.182-1.752,1.707-5.46,2.781-7.913a.012.012,0,0,1,.012-.012c.226-.52.429-.972.6-1.356.306-.238.554-.43.713-.565.011-.012.021-.012.034-.023a2.485,2.485,0,0,0,.2-.147c.147.418.294.859.418,1.333v.023c.011.012.011.012.011.023A11.362,11.362,0,0,1,2670.637,1318.668Z",
    transform: "translate(-5.543 -1.118)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M2664.252,1343.231c2.917,10.456,2.284,20.087.306,24.145-.316.644-1.062.4-2.081-.475-5.379-4.578-18.458-26.552-16.876-26.869,1.876-.374.939-13.847.848-14.605s-3.956-5.267-3.865-9.223,8.025-16.1,10.738-17.341c.566-.259,6.354-2.7,10.954-1.5s6,4.521,7.788,9.8-3.571,11.869-6.114,14.7a9.763,9.763,0,0,0-1.7,2.917C2662.692,1328.716,2662.025,1335.3,2664.252,1343.231Z",
    transform: "translate(-5.194 -0.981)",
    fill: "#f9acff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M2598.92,1361.052a9.384,9.384,0,0,1-.871.939,18.585,18.585,0,0,1-11.361,4.612c.5-.532.961-1.04,1.345-1.481.125-.147.261-.294.407-.463a49.94,49.94,0,0,1,4.555-3.1c1.537-.147,3.64-.328,4.884-.429C2598.513,1361.087,2598.92,1361.052,2598.92,1361.052Z",
    transform: "translate(-4.418 -1.87)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M2664.785,1367.766c-.317.644-1.063.4-2.081-.475-2.091-4.95-4.159-11.824-3.7-12.174.757-.565,3.956,2.633,4.906,0,.927-2.6-4.68-24.021.565-29.955-1.56,3.944-2.226,10.524,0,18.459C2667.4,1354.077,2666.763,1363.709,2664.785,1367.766Z",
    transform: "translate(-5.421 -1.372)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M2653.177,1374.126c-7.143-.621-15.859-5.483-23.806-19.431-.937-1.651-1.808-3.278-2.6-4.85a95.424,95.424,0,0,1-8.184-22.223,27.332,27.332,0,0,1-.995,10.964,32.06,32.06,0,0,1-3.787,7.935,52.822,52.822,0,0,1-8.365,9.778c-7.438,6.94-19.68,9.789-18.832,8.478s6.68-9.427,14.785-26.281,11.587-24.213,17.43-23.365,41.157,31.911,45.114,49.737C2664.843,1368.892,2662.152,1374.894,2653.177,1374.126Z",
    transform: "translate(-4.417 -1.232)",
    fill: "#a58cff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M2629.708,1316.332h0a.611.611,0,0,1-.862-.073l-13.6-16.134a.613.613,0,0,1,.073-.863h0a.613.613,0,0,1,.863.074l13.6,16.134A.611.611,0,0,1,2629.708,1316.332Z",
    transform: "translate(-4.813 -1.01)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M2682.452,1319.993c-3.458-3.458-9.009-11.53-13.395-26.541-5.731-19.646-12.582-24.292-19.092-27.117a11.923,11.923,0,0,1,1.571.079c5.493.633,14.514,3.957,20.731,24.3C2677.8,1308.791,2680.633,1316.455,2682.452,1319.993Z",
    transform: "translate(-5.297 -0.555)",
    fill: "#d9d9d9",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M2667.562,1397.019a20.634,20.634,0,0,1-1.537,5.493c-.938-2.023-1.57-5.731-1.57-9.969a27.082,27.082,0,0,1,1.458-9.688A33.3,33.3,0,0,1,2667.562,1397.019Z",
    transform: "translate(-5.498 -2.173)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M2585.969,1380.645a.471.471,0,0,1-.237.068c-1.583.046-11.349-.565-15.8-4.047a19.89,19.89,0,0,1-2.532-2.351,43.629,43.629,0,0,1,8.263,1.7A36.173,36.173,0,0,1,2585.969,1380.645Z",
    transform: "translate(-4.151 -2.054)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M2618.971,1327.753a27.334,27.334,0,0,1-.995,10.964,32.08,32.08,0,0,1-3.787,7.936c2.351-6.353,3.908-20.125,4.191-21.959.311-2.026,8.142,19.484,8.775,25.282A95.392,95.392,0,0,1,2618.971,1327.753Z",
    transform: "translate(-4.801 -1.364)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M2613.208,1768.287c-17.156,4.788-22.887,21.86-23.975,29.477-1.8,12.6-.679,29.342,6.656,34.912S2616.13,1767.471,2613.208,1768.287Z",
    transform: "translate(-4.444 -7.523)",
    fill: "#f9acff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M2659.312,1740.063c1.288-1.516,8.667.572,9.893,3.985s.361,5.756.769,7.183,1.376,2.9,1.12,3.413-4.584,3.26-5.144,1.681S2659.312,1740.063,2659.312,1740.063Z",
    transform: "translate(-5.427 -7.125)",
    fill: "#ffdbca"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M2659.079,1740.7c2.652-.293,8.44,5.181,8.692,6.25S2657.851,1740.837,2659.079,1740.7Z",
    transform: "translate(-5.422 -7.14)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M2662.254,1745.159c-.251,1.471,2.649,4.3,4.618,4.468S2662.356,1744.561,2662.254,1745.159Z",
    transform: "translate(-5.468 -7.202)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M2669.146,1748.249l-1.655,2.038a.13.13,0,0,1-.187.016l-.326-.26v-.009l-9.479-7.694-.04-.033a1.032,1.032,0,0,1-.147-1.451l.521-.636a1.025,1.025,0,0,1,1.451-.155l9.837,8A.125.125,0,0,1,2669.146,1748.249Z",
    transform: "translate(-5.396 -7.128)",
    fill: "#6a1b9a"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M2669.4,1748.284c-1.118-.9-2.6.6-2.217,1.682.347.974,1.367.854,2.011.129C2669.739,1749.482,2669.914,1748.7,2669.4,1748.284Z",
    transform: "translate(-5.535 -7.242)",
    fill: "#d6e7ff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M2657.235,1742.092a2.414,2.414,0,0,1,1.777-2.19l-4.668-1.876a.159.159,0,0,0-.183.248Z",
    transform: "translate(-5.355 -7.103)",
    fill: "#d6e7ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M2666.983,1750.069l-9.479-7.694a7.061,7.061,0,0,1,4.67,1.94A25.091,25.091,0,0,1,2666.983,1750.069Z",
    transform: "translate(-5.401 -7.164)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M2662.921,1748.876s-.928-5.6-2.541-5.54-1.055,3.9-.7,5.54,2.853,3.273,3.719,4.75,1.4,3.107,1.822,3.515,3.157-.283,3.317-.778S2662.921,1748.876,2662.921,1748.876Z",
    transform: "translate(-5.427 -7.177)",
    fill: "#ffdbca"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M2624.7,1767.82c9.132,1.791,22.224,12.476,29.458,11.973s12.108-4.273,12.371-10.9-2.815-12.645-2.55-13.013,5.3-2.9,6.418-2.176,10.827,22.457.639,32.305-18.407,10.325-29.615,4.89-16.722-23.084-16.722-23.084",
    transform: "translate(-4.946 -7.319)",
    fill: "#f9acff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M2615.5,1756.794c-1.7,9.073-1.732,13.448-.509,14.365s8.965,1.528,9.577,0-1.665-15.079-2.514-15.893S2615.692,1755.773,2615.5,1756.794Z",
    transform: "translate(-4.799 -7.339)",
    fill: "#ffdbca"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M2672.564,1833.468c-1.491,11.142-17.14,22.993-38.82,24.1-4.051.212-.709-11.2,11.924-23.017.693-.652,1.4-1.272,2.111-1.842l.04-.041a31.969,31.969,0,0,1,14.451-7.058.638.638,0,0,1,.089-.009C2668.8,1824.593,2673.4,1827.21,2672.564,1833.468Z",
    transform: "translate(-5.049 -8.316)",
    fill: "#a58cff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M2609.258,1857.224c-23.986-.953-38.927-11.818-41.641-25.673-1.23-6.26,3.415-8.257,9.912-7.344a42.405,42.405,0,0,1,16.162,6.447,39.212,39.212,0,0,1,8.565,7.328C2613.529,1851.242,2609.258,1857.224,2609.258,1857.224Z",
    transform: "translate(-4.151 -8.297)",
    fill: "#a58cff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M2594.96,1832.851c-.943,13.8,5.909,22.676,12.836,24.073s24.859,1.763,29.953-.355,13.448-10.168,8.558-24.057S2595.362,1826.951,2594.96,1832.851Z",
    transform: "translate(-4.533 -8.309)",
    fill: "#a58cff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M2610.629,1769.169c-7.786,3.3-21.671,51.334-15.777,60.992s18.56-40.264,19-48.721S2612.793,1768.253,2610.629,1769.169Z",
    transform: "translate(-4.512 -7.534)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M2662.542,1825.606a29.08,29.08,0,0,1-14.378,12.4s-6.438.937-.2-5.289l.041-.042a31.966,31.966,0,0,1,14.45-7.057A.651.651,0,0,1,2662.542,1825.606Z",
    transform: "translate(-5.231 -8.319)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M2596.554,1837.78c-11.329-1.671-18.884-13.571-18.884-13.571a42.416,42.416,0,0,1,16.163,6.447C2599.122,1836.06,2597.076,1837.862,2596.554,1837.78Z",
    transform: "translate(-4.293 -8.299)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M2632.255,1770.956a25.746,25.746,0,0,0-13.127-3.358c-7.268.271-8.6,1.4-10.654,2.466s-19.435,61.345-13.05,67.136,49.989,2.767,52.027,0S2634.412,1772.054,2632.255,1770.956Z",
    transform: "translate(-4.52 -7.513)",
    fill: "#f9acff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M2614.866,1759.271c3.256-.833,7.6-.582,8.282,0s6.593-.945,10.057-7.669a15,15,0,0,0,1.222-10.528,4.6,4.6,0,0,0-3.667-3.226,8.071,8.071,0,0,0-1.562-8.66c-3.736-4.347-7.947,0-7.947,0a4.626,4.626,0,0,0-5.366-3.192c-4.347.612-5.841,8.559-5.841,8.559s-5.094-.849-4.959,6.231S2610.111,1760.489,2614.866,1759.271Z",
    transform: "translate(-4.674 -6.935)",
    fill: "#11174f"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M2442.958,1512.825l9.84,53.058a1.671,1.671,0,0,1-1.32,1.921l-69.632,12.914a1.644,1.644,0,0,1-1.431-.425,1.608,1.608,0,0,1-.49-.894l-9.84-53.059a1.647,1.647,0,0,1,1.321-1.915l69.633-12.913A1.645,1.645,0,0,1,2442.958,1512.825Z",
    transform: "translate(-1.411 -3.958)",
    fill: "#ffd740"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M2409.536,1550.171c-.259,1.457-11.292,18.527-12.391,21.492-.823,2.245-9.537,7.516-14.084,9.359l-1.069.2a1.644,1.644,0,0,1-1.431-.425c2.236-4.654,21.593-28.727,25.287-33.117a14.32,14.32,0,0,1,1.449.484C2408.392,1548.608,2409.687,1549.319,2409.536,1550.171Z",
    transform: "translate(-1.557 -4.461)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M2453.163,1567.478a1.589,1.589,0,0,1-1.1.774l-10.077,1.87c-6.4-4.66-30.062-26.354-30.062-26.354,9.149,3.53,33.569,18.076,35.026,18.981C2448.22,1563.542,2452.2,1566.064,2453.163,1567.478Z",
    transform: "translate(-1.993 -4.407)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M2451.573,1568.263l-69.51,12.891a.632.632,0,0,1-.6-1.021l25.848-32.025,3.385-4.192a.631.631,0,0,1,.8-.149l40.276,23.326A.632.632,0,0,1,2451.573,1568.263Z",
    transform: "translate(-1.567 -4.405)",
    fill: "#ffde63"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M2370.782,1525.382l40.968,27.295a1.222,1.222,0,0,0,1.673-.309l28.552-40.188a.482.482,0,0,0-.48-.752l-70.534,13.081A.482.482,0,0,0,2370.782,1525.382Z",
    transform: "translate(-1.418 -3.957)",
    fill: "#fff48c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M2372.147,1555.764c7.288-6.316,15.872-11.984,19.919-8.583s12.309,27.208,7.45,33.362S2372.147,1555.764,2372.147,1555.764Z",
    transform: "translate(-1.44 -4.44)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M2389.053,1549.454l19.96,50.137a1.674,1.674,0,0,1-.922,2.141l-65.8,26.194a1.645,1.645,0,0,1-1.487-.139,1.6,1.6,0,0,1-.653-.783l-19.96-50.136a1.647,1.647,0,0,1,.924-2.135l65.8-26.194A1.647,1.647,0,0,1,2389.053,1549.454Z",
    transform: "translate(-0.718 -4.471)",
    fill: "#ffd740"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M2363.573,1592.709c.029,1.479-7.479,20.367-7.98,23.489-.372,2.362-7.9,9.226-12,11.917l-1.01.4a1.646,1.646,0,0,1-1.487-.139c1.29-5,15.6-32.374,18.373-37.4a14.373,14.373,0,0,1,1.516.194C2362.15,1591.4,2363.556,1591.843,2363.573,1592.709Z",
    transform: "translate(-1.009 -5.062)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M2409.64,1601.281a1.594,1.594,0,0,1-.931.974l-9.523,3.791c-7.184-3.327-34.608-20.011-34.608-20.011,9.66,1.684,36.441,11.209,38.045,11.815C2404.028,1598.379,2408.424,1600.08,2409.64,1601.281Z",
    transform: "translate(-1.335 -4.993)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M2408.334,1602.277l-65.682,26.149a.633.633,0,0,1-.792-.885L2361,1591.106l2.507-4.77a.629.629,0,0,1,.759-.3l44.04,15.057A.632.632,0,0,1,2408.334,1602.277Z",
    transform: "translate(-1.019 -4.993)",
    fill: "#ffde63"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M2320.689,1575.794l45.488,18.817a1.222,1.222,0,0,0,1.582-.628l20.2-44.97a.481.481,0,0,0-.617-.644l-66.649,26.533A.482.482,0,0,0,2320.689,1575.794Z",
    transform: "translate(-0.722 -4.47)",
    fill: "#fff48c"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M2437.938,1387.479l16.217-8.526a2.107,2.107,0,0,1,3.058,2.222l-3.1,18.058a2.108,2.108,0,0,0,.607,1.866l13.12,12.789a2.107,2.107,0,0,1-1.169,3.594l-18.131,2.635a2.108,2.108,0,0,0-1.587,1.153l-8.108,16.43a2.108,2.108,0,0,1-3.78,0l-8.109-16.43a2.108,2.108,0,0,0-1.586-1.153l-18.132-2.635a2.107,2.107,0,0,1-1.169-3.594l13.121-12.789a2.108,2.108,0,0,0,.606-1.866l-3.1-18.058a2.107,2.107,0,0,1,3.058-2.222l16.218,8.526A2.111,2.111,0,0,0,2437.938,1387.479Z",
    transform: "translate(-1.902 -2.115)",
    fill: "#f8a1c0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M2413.124,1455.4l11.385-3.147a1.358,1.358,0,0,1,1.622,1.818l-4.428,10.951a1.358,1.358,0,0,0,.126,1.258l6.51,9.856a1.358,1.358,0,0,1-1.228,2.1l-11.783-.827a1.358,1.358,0,0,0-1.158.509l-7.361,9.238a1.359,1.359,0,0,1-2.381-.519l-2.855-11.462a1.356,1.356,0,0,0-.841-.944l-11.06-4.146a1.359,1.359,0,0,1-.243-2.425l10.019-6.257a1.361,1.361,0,0,0,.638-1.093l.525-11.8a1.359,1.359,0,0,1,2.231-.98l9.047,7.6A1.365,1.365,0,0,0,2413.124,1455.4Z",
    transform: "translate(-1.672 -3.066)",
    fill: "#f8c4d5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M2380.73,1415.463l8.688,2.512a1.041,1.041,0,0,1,.33,1.836l-7.279,5.369a1.035,1.035,0,0,0-.422.871l.3,9.04a1.04,1.04,0,0,1-1.645.88l-7.356-5.263a1.038,1.038,0,0,0-.958-.132l-8.505,3.075a1.041,1.041,0,0,1-1.346-1.293l2.733-8.621a1.039,1.039,0,0,0-.171-.953l-5.553-7.139a1.041,1.041,0,0,1,.814-1.679l9.044-.065a1.04,1.04,0,0,0,.853-.456l5.074-7.488a1.041,1.041,0,0,1,1.849.255l2.857,8.581A1.037,1.037,0,0,0,2380.73,1415.463Z",
    transform: "translate(-1.262 -2.487)",
    fill: "#f8abab"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M2562.828,1320.266l-91.774-26.358,9,13.335Z",
    transform: "translate(-2.813 -0.938)",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M2562.938,1320.453l-82.775-13.023-1.23,33.239Z",
    transform: "translate(-2.923 -1.126)",
    fill: "#c7d6ff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2334.177 1440.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M2341.142,1453.367a.808.808,0,0,0,.65-1.287,70.935,70.935,0,0,1-5.17-8.111.809.809,0,0,0-1.42.773,72.879,72.879,0,0,0,5.29,8.3A.809.809,0,0,0,2341.142,1453.367Z",
    transform: "translate(-2335.104 -1443.55)",
    fill: "#5d7ade"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2326.981 1420.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M2331.112,1434.214a.809.809,0,0,0,.763-1.07,67.738,67.738,0,0,1-2.466-9.29.817.817,0,0,0-.947-.642.8.8,0,0,0-.641.945,69,69,0,0,0,2.527,9.511A.807.807,0,0,0,2331.112,1434.214Z",
    transform: "translate(-2327.806 -1423.198)",
    fill: "#5d7ade"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(2325.889 1395.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M2327.506,1411.747a.806.806,0,0,0,.807-.8,59.678,59.678,0,0,1,1.55-12.581.807.807,0,1,0-1.571-.37,61.083,61.083,0,0,0-1.594,12.926.809.809,0,0,0,.8.821Z",
    transform: "translate(-2326.699 -1397.379)",
    fill: "#5d7ade"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(2331.451 1374.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M2333.147,1387.33a.8.8,0,0,0,.729-.463,59.1,59.1,0,0,1,5.35-9.063.807.807,0,0,0-1.312-.94,60.3,60.3,0,0,0-5.5,9.313.807.807,0,0,0,.382,1.076A.825.825,0,0,0,2333.147,1387.33Z",
    transform: "translate(-2332.339 -1376.525)",
    fill: "#5d7ade"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(2345.247 1358.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M2347.137,1368.427a.812.812,0,0,0,.552-.218,72.1,72.1,0,0,1,7.682-6.234.807.807,0,0,0-.927-1.321,73.6,73.6,0,0,0-7.86,6.375.808.808,0,0,0,.552,1.4Z",
    transform: "translate(-2346.329 -1360.507)",
    fill: "#5d7ade"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(2363.171 1347.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M2365.312,1355.682a.814.814,0,0,0,.385-.1c3.361-1.824,6.913-3.532,10.559-5.082a.808.808,0,0,0,.429-1.058.8.8,0,0,0-1.06-.428c-3.694,1.568-7.29,3.3-10.7,5.147a.807.807,0,0,0,.384,1.518Z",
    transform: "translate(-2364.505 -1348.948)",
    fill: "#5d7ade"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(2385.435 1338.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M2387.889,1346.1a.844.844,0,0,0,.253-.039c4.785-1.566,9.852-2.98,15.061-4.206a.8.8,0,0,0,.6-.969.794.794,0,0,0-.971-.6c-5.25,1.234-10.364,2.661-15.194,4.24a.808.808,0,0,0,.252,1.576Z",
    transform: "translate(-2387.082 -1340.255)",
    fill: "#5d7ade"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(2411.91 1334.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M2414.737,1339.539a.771.771,0,0,0,.133-.012,162.914,162.914,0,0,1,16.55-1.916.808.808,0,0,0,.755-.857.825.825,0,0,0-.855-.755,164.242,164.242,0,0,0-16.715,1.936.808.808,0,0,0,.132,1.6Z",
    transform: "translate(-2413.93 -1335.997)",
    fill: "#5d7ade"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(2439.209 1334.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M2460.8,1337.992a.808.808,0,0,0,.069-1.612c-6.132-.526-12.385-.781-18.455-.745a.808.808,0,0,0,0,1.615h0c6.066-.016,12.23.216,18.31.739Z",
    transform: "translate(-2441.613 -1335.632)",
    fill: "#5d7ade"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(2788.389 1368.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M2839.2,1378.793c.643,5.581-8.564,11.226-20.566,12.61s-22.252-2.018-22.9-7.6,8.563-11.226,20.564-12.611S2838.558,1373.212,2839.2,1378.793Z",
    transform: "translate(-2795.709 -1370.177)",
    fill: "#ffe852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M2827.451,1371.571c-10.089-3.642-18.371.787-19.637,2.221s.025,5.414,3.875,3.344,7.011-3.659,11.606-4.479S2829.914,1372.46,2827.451,1371.571Z",
    transform: "translate(-2795.871 -1370.167)",
    fill: "#fff",
    opacity: 0.8
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M2489.368,1320.489l-10.436,20.363,84.005-20.217Z",
    transform: "translate(-2.923 -1.307)",
    fill: "#94afff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M2502.575,1345.91l60.51-25.276-73.569-.146Z",
    transform: "translate(-3.07 -1.307)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevelopment);
export default __webpack_public_path__ + "static/media/app-development.5d282aa1ef8f46c88db507fa9945a882.svg";
export { ForwardRef as ReactComponent };